/**
 * Native Skin Age Quiz (NSAQ)
 * Vanilla JS. No globals leaked (single IIFE). Safe for repeated Theme
 * Editor section reloads. All DOM queries are scoped to one .nsaq-root.
 */
(function () {
  "use strict";

  /* ------------------------------------------------------------------
   * STEP CONFIG — verified from 24 reference screenshots + live page.
   * Hash IDs match the real quiz exactly (#age, #frustrations, etc).
   * Result/offer values are FIXED, not computed — see audit notes.
   * No branching is implemented: none was verified in any screenshot.
   * ------------------------------------------------------------------ */
  function buildSteps(img) {
    return [
      {
        id: "age",
        type: "single",
        autoAdvance: true,
        eyebrowIsHeadline: true,
        title: "How old are you? 🤔",
        options: [
          { id: "under-40", label: "Under 40" },
          { id: "40-49", label: "40-49" },
          { id: "50-59", label: "50-59" },
          { id: "over-60", label: "Over 60" },
          { id: "over-70", label: "Over 70" }
        ]
      },
      {
        id: "frustrations",
        type: "multi",
        title: "What is your biggest frustration when you look in the mirror? 🤷‍♂️",
        hint: "(Choose as many as you like)",
        options: [
          { id: "deep-wrinkles", label: "Deep Wrinkles" },
          { id: "tired-face", label: "Tired, Worn-Out Face" },
          { id: "dry-texture", label: "Dry/Leathery Texture" },
          { id: "turkey-neck", label: "Turkey Neck" },
          { id: "eye-bags", label: "Eye Bags" }
        ]
      },
      {
        id: "skin-observation",
        type: "single",
        autoAdvance: true,
        title: "How noticeable are these issues?",
        options: [
          { id: "starting", label: "Just starting", desc: "I see them, but others might not." },
          { id: "clearly-visible", label: "Clearly visible", desc: "People have commented on them (or I notice them in photos)." },
          { id: "deep-severe", label: "Deep/Severe", desc: "It makes me look much older than I feel." }
        ]
      },
      {
        id: "pain-point",
        type: "multi",
        gridImages: true,
        title: "Which areas make your face look older or more tired than you feel?",
        hint: "(Choose all that apply)",
        options: [
          { id: "forehead", label: "Forehead lines / deep creases", image: img.areaForehead },
          { id: "crows-feet", label: "Crows Feet", image: img.areaCrowsFeet },
          { id: "eye-bags-dark", label: "Eye bags & dark circles", image: img.areaEyeBags },
          { id: "turkey-neck-loose", label: "Turkey neck / loose neck skin", image: img.areaTurkeyNeck }
        ]
      },
     {
  id: "before-and-after",
  type: "content",
  title: "You are in the right place! 💪",
  bodyHtml: 'Thousands of men over 40 have restored a firmer, more rested-looking face and reduced deep wrinkles — without surgery — using the <strong>Italian approach</strong> behind SerlinoLab.',
  images: [
    img.beforeAfter1,
    img.beforeAfter1Slide2,
    img.beforeAfter1Slide3
  ].filter(Boolean)
},
      {
        id: "sun-exposure",
        type: "single",
        autoAdvance: true,
        title: "How often is your skin exposed to the sun or harsh weather?",
        options: [
          { id: "constantly", icon: "☀️", label: "Constantly", desc: "(I work or play outside)" },
          { id: "sometimes", icon: "🌤️", label: "Sometimes" },
          { id: "rarely", icon: "☁️", label: "Rarely", desc: "(Office/Indoors)" },
          { id: "not-sure", icon: "🤷‍♂️", label: "I'm not sure" }
        ]
      },
      {
        id: "stress",
        type: "single",
        autoAdvance: true,
        title: "I feel the pressure of stress…",
        options: [
          { id: "every-day", icon: "😰", label: "Every day, constantly" },
          { id: "most-days", icon: "😬", label: "Most days, especially at work" },
          { id: "busy-periods", icon: "😕", label: "Mainly during busy periods" },
          { id: "rarely-stressed", icon: "😎", label: "I rarely feel stressed" }
        ]
      },
      {
        id: "sensitive-skin",
        type: "single",
        autoAdvance: true,
        title: "Do you have sensitive skin? 🤔",
        options: [
          { id: "yes", label: "Yes" },
          { id: "no", label: "No" },
          { id: "not-sure", label: "I am not sure" }
        ]
      },
      {
        id: "youre-a-great-fit",
        type: "content",
        title: "Congratulations, you are a great fit! ✅",
        body: "Our formulation is specifically engineered for men's thicker skin structure. It is safe, effective, and 100% Non-Greasy.",
        image: img.greatFitMontage
      },
      {
  id: "loading-skin-profile",
  type: "loading",
  title: "Creating your skin profile…",
  showCheckBeforeNext: true,
  checkAfterMs: 1400,
  durationMs: 2200
},
      {
        id: "summary-skin-profile",
        type: "result",
        title: "Summary of Skin Profile",
        image: img.profileModel
        // Fixed result values — see renderResult(). Not computed from answers.
      },
      {
        id: "past-regimen",
        type: "multi",
        title: "What have you tried in the past?",
        hint: "(Choose all that apply)",
        options: [
          { id: "beef-tallow", icon: "🥩", label: "Beef Tallow" },
          { id: "drugstore", icon: "🧴", label: "Generic drugstore creams", desc: "(Nivea, L'Oreal, CeraVe)" },
          { id: "in-clinic", icon: "💉", label: "In-clinic treatments", desc: "(Botox, Fillers)" },
          { id: "partner-products", icon: "👩", label: "My wife/partner's products" },
          { id: "soap-water", icon: "🧼", label: "Just soap and water" },
          { id: "nothing", icon: "❌", label: "Nothing yet" }
        ]
      },
      {
        id: "before-and-after-2",
        type: "content",
        title: "Why most men's products fail.",
        bodyParagraphs: [
          "Drugstore creams just hydrate the surface and do nothing about the collagen loss underneath.",
          "Instead SerlinoLab uses a bio-identical form of Vitamin A that your skin recognizes and absorbs instantly — rebuilding collagen while you sleep. Zero grease. Real results."
        ],
       images: [
  img.beforeAfter2,
  img.beforeAfter2Slide2,
  img.beforeAfter2Slide3
].filter(Boolean)
      },
      {
        id: "skincare-time",
        type: "single",
        autoAdvance: true,
        title: "How much time do you have for a daily routine? ⏱️",
        options: [
          { id: "30-seconds", label: "I want it done in 30 seconds" },
          { id: "1-2-min", label: "1–2 minutes" },
          { id: "10-min", label: "10 minutes" },
          { id: "15-min", label: "15 minutes" },
          { id: "20-min", label: "20 minutes" },
          { id: "not-sure", label: "I am not sure" }
        ]
      },
      {
        id: "loading",
        type: "loading",
        title: "A busy schedule doesn't have to stop you from looking years younger…",
        bodyHtml: "With SerlinoLab you can visibly rejuvenate your skin <u>in just 2 minutes every night…</u>",
        footnote: "Loading next question.",
        durationMs: 1400
      },
      {
        id: "age-perception",
        type: "single",
        autoAdvance: true,
        title: "Have you ever felt like your face makes you look older than you feel inside? 🤔",
        options: [
          { id: "yes", label: "Yes" },
          { id: "no", label: "No" },
          { id: "sometimes", label: "Sometimes" }
        ]
      },
      {
        id: "ideal-perception-after-usage",
        type: "single",
        autoAdvance: true,
        title: "How would it feel to look as young as you actually feel?",
        options: [
          { id: "stop-old-guy", label: "I'd stop being the \"old guy\" in the room." },
          { id: "stop-avoiding-mirrors", label: "I'd stop avoiding mirrors and dreading photos." },
          { id: "feel-attractive", label: "I'd feel attractive again — to my partner or out there." },
          { id: "all-of-above", label: "All of the above." }
        ]
      },
      {
        id: "upcoming-event",
        type: "single",
        autoAdvance: true,
        title: "Do you have an important event coming up?",
        options: [
          { id: "wedding", icon: "💍", label: "My daughter's/son's wedding" },
          { id: "holiday", icon: "🏖️", label: "Holiday / Trip" },
          { id: "reunion", icon: "👫", label: "Class Reunion" },
          { id: "business", icon: "🤝", label: "Business Event" },
          { id: "no-event", icon: "❌", label: "No specific event, I just want to fix this now." }
        ]
      },
      {
        id: "event-date",
        type: "date",
        title: "When is your event?",
        body: "We will keep this in mind for your treatment.",
        skippable: true
      },
      {
        id: "quiz-results",
        type: "offer",
        before: img.offerNowModel,
        after: img.offerGoalModel
      },
    {
  id: "last-loader-screen",
  type: "loading",
  title: "Applying special one-time discount…",
  checkIcon: false,
  durationMs: 1800,
  isFinal: true
}
    ];
  }

  /* ------------------------------------------------------------------
   * Small inline icon set — avoids hotlinking third-party CDN SVGs.
   * ------------------------------------------------------------------ */
  var ICONS = {
    shield: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M12 3l7 3v6c0 5-3 8-7 9-4-1-7-4-7-9V6l7-3z"/></svg>',
    graph: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M4 19V5M4 19h16M8 15l3-4 3 2 4-6"/></svg>',
    bolt: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M13 2 4 14h6l-1 8 9-12h-6l1-8z"/></svg>',
    magnifier: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><circle cx="10" cy="10" r="6"/><path d="M20 20l-5.2-5.2"/></svg>',
    check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><circle cx="12" cy="12" r="10"/><path d="M8 12l3 3 5-6"/></svg>',
    chevron: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M9 6l6 6-6 6"/></svg>'
  };

  /* ------------------------------------------------------------------
   * Helpers
   * ------------------------------------------------------------------ */
  function safeStorage() {
    try {
      var k = "__nsaq_test__";
      window.sessionStorage.setItem(k, "1");
      window.sessionStorage.removeItem(k);
      return window.sessionStorage;
    } catch (e) {
      return null;
    }
  }

  function pushDataLayerEvent(eventName, detail) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: eventName }, detail));
    } catch (e) { /* analytics must never block the quiz */ }
  }

  function getQueryParam(name) {
    try { return new URLSearchParams(window.location.search).get(name); }
    catch (e) { return null; }
  }

  function getUtmParams() {
    var keys = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];
    var out = {};
    keys.forEach(function (k) { var v = getQueryParam(k); if (v) out[k] = v; });
    return out;
  }

  function generateSessionId() {
    return "nsaq_" + Date.now().toString(36) + "_" + Math.random().toString(36).slice(2, 10);
  }

  function escapeHtml(str) {
    if (str == null) return "";
    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
  }

  /* Verified dynamic calculation: today + 6 months, formatted "Month D, YYYY".
     This matches the live quiz exactly (e.g. captured on screenshot as
     "March 9, 2027" for a session started ~Sept 9, 2026). Everything else
     on this screen is fixed copy, not computed. */
  function formatSixMonthsFromNow() {
    var d = new Date();
    d.setMonth(d.getMonth() + 6);
    var months = ["January","February","March","April","May","June","July","August","September","October","November","December"];
    return months[d.getMonth()] + " " + d.getDate() + ", " + d.getFullYear();
  }

  /* ------------------------------------------------------------------
   * Quiz instance factory — one per .nsaq-root found on the page.
   * ------------------------------------------------------------------ */
  function initQuiz(root) {
    if (root.getAttribute("data-nsaq-initialized") === "true") return;
    root.setAttribute("data-nsaq-initialized", "true");

    var configEl = root.querySelector("[data-nsaq-config]");
    var cfg = {};
    try { cfg = JSON.parse(configEl ? configEl.textContent : "{}"); } catch (e) { cfg = {}; }
    cfg.images = cfg.images || {};

    var sectionId = cfg.sectionId || root.getAttribute("data-nsaq-section-id") || "default";
    var STEPS = buildSteps(cfg.images);

    var stage = root.querySelector("[data-nsaq-stage]");
    var progressTrack = root.querySelector("[data-nsaq-progress-track]");
    var progressFill = root.querySelector("[data-nsaq-progress-fill]");
    var navEl = root.querySelector("[data-nsaq-nav]");
    var backBtn = root.querySelector("[data-nsaq-back]");
    var continueBtn = root.querySelector("[data-nsaq-continue]");
    var liveRegion = root.querySelector("[data-nsaq-live-region]");

    var storage = safeStorage();
    var storageKey = "nsaq_state_" + cfg.quizName + "_" + cfg.quizVersion + "_" + sectionId;
    var variantId = getQueryParam("nsaq_variant") || (window.NSAQ_VARIANT_ID || null);

    var state = {
      sessionId: generateSessionId(),
      currentIndex: 0,
      answers: {},
      startedAt: Date.now(),
      hasStarted: false,
      completed: false
    };

    if (storage) {
      try {
        var saved = JSON.parse(storage.getItem(storageKey) || "null");
        if (saved && typeof saved === "object" && saved.sessionId) state = saved;
      } catch (e) { /* corrupt storage — start fresh */ }
    }

    // ---- pending timer tracking so nothing keeps running after navigation ----
    var pendingTimers = [];
    function scheduleTimer(fn, ms) {
      var id = window.setTimeout(fn, ms);
      pendingTimers.push(id);
      return id;
    }
    function clearAllTimers() {
      pendingTimers.forEach(function (id) { window.clearTimeout(id); });
      pendingTimers = [];
    }

    // ---- transition lock to guard against rapid repeated clicks ----
    var isTransitioning = false;

    function persist() {
      if (!storage) return;
      try { storage.setItem(storageKey, JSON.stringify(state)); } catch (e) { /* ignore */ }
    }

    function currentStep() { return STEPS[state.currentIndex]; }
    function findIndexById(id) {
      for (var i = 0; i < STEPS.length; i++) if (STEPS[i].id === id) return i;
      return -1;
    }
    function getNextStepId(fromStep) {
      // Linear only — no branching was verified in any reference screenshot.
      var idx = findIndexById(fromStep.id);
      var next = STEPS[idx + 1];
      return next ? next.id : null;
    }

   function updateProgress() {
  var pct = Math.round(
    ((state.currentIndex + 1) / STEPS.length) * 100
  );

  progressFill.style.width = pct + "%";
  progressTrack.setAttribute("aria-valuenow", String(pct));
}

    function announce(text) { if (liveRegion) liveRegion.textContent = text || ""; }

    function baseEventPayload(extra) {
      return Object.assign({
        quiz_name: cfg.quizName,
        quiz_version: cfg.quizVersion,
        session_id: state.sessionId,
        variant_id: variantId,
        current_url: window.location.href,
        utm: getUtmParams()
      }, extra || {});
    }

    function setContinueEnabled(enabled) { continueBtn.disabled = !enabled; }
    function isMultiAnswered(step) {
      var v = state.answers[step.id];
      return Array.isArray(v) && v.length > 0;
    }

    function inputId(step, optId) {
      return "nsaq-" + sectionId + "-" + step.id + "-" + optId;
    }

    /* ---------------- Rendering ---------------- */

    function renderOptions(step) {
      var list = document.createElement("ul");
      list.className = "nsaq-options" + (step.gridImages ? " nsaq-options--grid" : "");
      list.setAttribute("role", step.type === "multi" ? "group" : "radiogroup");
      list.setAttribute("aria-label", step.title.replace(/<[^>]+>/g, ""));

      var saved = state.answers[step.id];

      step.options.forEach(function (opt) {
        var li = document.createElement("li");
        li.className = "nsaq-option";

        var input = document.createElement("input");
        input.className = "nsaq-option-input";
        input.type = step.type === "multi" ? "checkbox" : "radio";
        input.name = "nsaq-" + sectionId + "-" + step.id;
        input.id = inputId(step, opt.id);
        input.value = opt.id;
        input.setAttribute("data-nsaq-option-input", "");

        if (step.type === "multi") {
          input.checked = Array.isArray(saved) && saved.indexOf(opt.id) !== -1;
        } else {
          input.checked = saved === opt.id;
        }

        var label = document.createElement("label");
        label.className = "nsaq-option-label";
        label.setAttribute("for", input.id);
        label.setAttribute("data-nsaq-option-id", opt.id);

        if (step.gridImages && opt.image) {
          label.innerHTML =
            '<img class="nsaq-option-image" src="' + escapeHtml(opt.image) + '" alt="" loading="lazy" width="150" height="96">' +
            '<span class="nsaq-option-title">' + escapeHtml(opt.label) + "</span>";
        } else {
          var media = opt.image
            ? '<img class="nsaq-option-image" src="' + escapeHtml(opt.image) + '" alt="" loading="lazy" width="44" height="44" style="width:44px;height:44px;border-radius:8px;">'
            : (opt.icon ? '<span class="nsaq-option-icon" aria-hidden="true">' + opt.icon + "</span>" : "");
          var desc = opt.desc ? '<span class="nsaq-option-desc">' + escapeHtml(opt.desc) + "</span>" : "";
          label.innerHTML =
            media +
            '<span class="nsaq-option-text"><span class="nsaq-option-title">' + escapeHtml(opt.label) + "</span>" + desc + "</span>";
        }

        li.appendChild(input);
        li.appendChild(label);
        list.appendChild(li);
      });

      list.addEventListener("change", function (e) {
        var target = e.target;
        if (!target || !target.matches("[data-nsaq-option-input]")) return;
        handleOptionChange(step, target);
      });

      return list;
    }

    function handleOptionChange(step, input) {
      if (isTransitioning) return;

      if (step.type === "multi") {
        var current = Array.isArray(state.answers[step.id]) ? state.answers[step.id].slice() : [];
        if (input.checked) {
          if (current.indexOf(input.value) === -1) current.push(input.value);
        } else {
          current = current.filter(function (v) { return v !== input.value; });
        }
        state.answers[step.id] = current;
        setContinueEnabled(current.length > 0);
      } else {
        state.answers[step.id] = input.value;
        setContinueEnabled(true);
      }

      persist();

      pushDataLayerEvent("native_quiz_answer", baseEventPayload({
        step_id: step.id,
        step_number: state.currentIndex + 1,
        answer_id: state.answers[step.id]
      }));

      if (step.autoAdvance && step.type === "single") {
        clearAllTimers();
        scheduleTimer(function () { goNext(); }, 260);
      }
    }

function renderSwipeSlider(images) {
  var container = document.createElement("div");
  container.className = "nsaq-media-wrap";

  var slider = document.createElement("div");
  slider.className = "nsaq-slider";

  var track = document.createElement("div");
  track.className = "nsaq-slider-track";

  var dots = document.createElement("div");
  dots.className = "nsaq-carousel-dots";
  dots.setAttribute("aria-label", "Slider pagination");

  images.forEach(function (imageUrl, index) {
    var slide = document.createElement("div");
    slide.className = "nsaq-slider-slide";

    var image = document.createElement("img");
    image.src = imageUrl;
    image.alt = "";
    image.loading = index === 0 ? "eager" : "lazy";
    image.width = 480;
    image.height = 330;

    slide.appendChild(image);
    track.appendChild(slide);

    var dot = document.createElement("button");
    dot.type = "button";
    dot.className =
      "nsaq-carousel-dot" +
      (index === 0 ? " nsaq-carousel-dot--active" : "");

    dot.setAttribute("aria-label", "Go to slide " + (index + 1));

    dot.addEventListener("click", function () {
      track.scrollTo({
        left: track.clientWidth * index,
        behavior: "smooth"
      });
    });

    dots.appendChild(dot);
  });

  var updateActiveDot = function () {
    var activeIndex = Math.round(track.scrollLeft / track.clientWidth);

    dots.querySelectorAll(".nsaq-carousel-dot").forEach(function (dot, index) {
      dot.classList.toggle(
        "nsaq-carousel-dot--active",
        index === activeIndex
      );
    });
  };

  track.addEventListener("scroll", updateActiveDot, { passive: true });

  slider.appendChild(track);
  container.appendChild(slider);
  container.appendChild(dots);

  return container;
}

    function renderStepMarkup(step) {
      var wrap = document.createElement("div");
      wrap.className = "nsaq-step";
      wrap.setAttribute("data-nsaq-step-id", step.id);
      wrap.setAttribute("data-nsaq-active", "true");
      wrap.setAttribute("role", "group");
      wrap.setAttribute("aria-roledescription", "quiz step");

      if (step.eyebrowIsHeadline) {
        var eyebrow = document.createElement("p");
        eyebrow.className = "nsaq-eyebrow";
        var headlineText =
  cfg.headline ||
  "Take This 1-Minute Quiz To Claim Your US Launch $71 Discount!";
var underlinedPhrase = "Claim Your US Launch $71 Discount!";
var phrasePosition = headlineText.indexOf(underlinedPhrase);

if (phrasePosition !== -1) {
  eyebrow.appendChild(
    document.createTextNode(headlineText.slice(0, phrasePosition))
  );

  var underlinedText = document.createElement("u");
  underlinedText.textContent = underlinedPhrase;
  eyebrow.appendChild(underlinedText);
} else {
  eyebrow.textContent = headlineText;
}
        wrap.appendChild(eyebrow);
      }

      if (step.title) {
        var title = document.createElement("h2");
        title.className = "nsaq-title";
        title.textContent = step.title;
        wrap.appendChild(title);
      }

      if (step.hint) {
        var hint = document.createElement("p");
        hint.className = "nsaq-hint";
        hint.textContent = step.hint;
        wrap.appendChild(hint);
      }

    

      if (step.body) {
        var body = document.createElement("p");
        body.className = "nsaq-body-copy";
        body.textContent = step.body;
        wrap.appendChild(body);
      }
      if (step.bodyHtml) {
        var bodyHtml = document.createElement("p");
        bodyHtml.className = "nsaq-body-copy";
        bodyHtml.innerHTML = step.bodyHtml; // static, developer-authored copy only
        wrap.appendChild(bodyHtml);
      }
      if (step.bodyParagraphs) {
        step.bodyParagraphs.forEach(function (p) {
          var para = document.createElement("p");
          para.className = "nsaq-body-copy";
          para.textContent = p;
          wrap.appendChild(para);
        });
      }

   if (step.type === "content") {
  var slideImages = Array.isArray(step.images)
    ? step.images.filter(Boolean)
    : step.image
      ? [step.image]
      : [];

if (slideImages.length) {
  if (slideImages.length > 1) {
    wrap.appendChild(renderSwipeSlider(slideImages));
  } else {
    var mediaWrap = document.createElement("div");
    mediaWrap.className = "nsaq-media-wrap";

    var mediaImage = document.createElement("img");
    mediaImage.className = "nsaq-media";
    mediaImage.src = slideImages[0];
    mediaImage.alt = "";
    mediaImage.loading = "lazy";

    mediaWrap.appendChild(mediaImage);
    wrap.appendChild(mediaWrap);
  }
}
}

      if (step.type === "single" || step.type === "multi") {
        wrap.appendChild(renderOptions(step));
      }

      if (step.type === "loading") {
        if (step.checkIcon) {
          var checkWrap = document.createElement("div");
          checkWrap.className = "nsaq-loading-icon";
          checkWrap.innerHTML = ICONS.check;
          checkWrap.setAttribute("aria-hidden", "true");
          wrap.appendChild(checkWrap);
        } else {
          var spinner = document.createElement("div");
          spinner.className = "nsaq-loading-spinner";
          spinner.setAttribute("aria-hidden", "true");
          wrap.appendChild(spinner);
        }
        if (step.footnote) {
          var foot = document.createElement("p");
          foot.className = "nsaq-hint";
          foot.textContent = step.footnote;
          wrap.appendChild(foot);
        }
      }

      if (step.type === "result") wrap.appendChild(renderResult(step));
      if (step.type === "date") wrap.appendChild(renderDateStep(step));
      if (step.type === "offer") wrap.appendChild(renderOffer(step));

      return wrap;
    }

    /* Fixed result content — verified identical across every screenshot.
       No scoring formula is applied; nothing here is computed from answers. */
    function renderResult(step) {
      var box = document.createElement("div");
      box.className = "nsaq-result-card";
      box.innerHTML =
        '<div class="nsaq-result-top">' +
          '<span class="nsaq-result-label">Level of Skin Aging</span>' +
          '<span class="nsaq-pill nsaq-pill--high">High</span>' +
        "</div>" +
        (step.image ? '<img class="nsaq-result-photo" src="' + escapeHtml(step.image) + '" alt="" loading="lazy" width="140" height="180">' : "") +
        '<div class="nsaq-gauge-track">' +
  '<span class="nsaq-gauge-level" style="left:88%">Your level</span>' +
  '<span class="nsaq-gauge-marker" style="left:88%"></span>' +
'</div>' +
        '<div class="nsaq-gauge-labels"><span>Low</span><span>Normal</span><span>Medium</span><span>High</span></div>' +
       '<div class="nsaq-alert-box">' +
  '<span class="nsaq-alert-icon" aria-hidden="true">' +
    '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">' +
      '<path d="M10 20C15.51 20 20 15.51 20 10C20 4.49 15.51 0 10 0C4.49 0 0 4.49 0 10C0 15.51 4.49 20 10 20ZM10.75 14C10.75 14.41 10.41 14.75 10 14.75C9.59 14.75 9.25 14.41 9.25 14V9C9.25 8.59 9.59 8.25 10 8.25C10.41 8.25 10.75 8.59 10.75 9V14ZM10 5C10.55 5 11 5.45 11 6C11 6.55 10.55 7 10 7C9.45 7 9 6.55 9 6C9 5.45 9.45 5 10 5Z" fill="currentColor"></path>' +
    '</svg>' +
  '</span>' +
  '<span class="nsaq-alert-content">' +
    '<strong>HIGH Level</strong>' +
    '<span>Your skin is aging 40-60% faster than normal for your age. This is caused by severe collagen depletion, stress-induced breakdown, and accumulated UV damage.</span>' +
  '</span>' +
'</div>' +
        '<div class="nsaq-fact-grid">' +
         '<div class="nsaq-fact-card"><span class="nsaq-fact-icon"><img src="' + escapeHtml(cfg.extrinsicIcon) + '" alt="" width="28" height="28"></span><span><span class="nsaq-fact-label">Aging type</span><br><span class="nsaq-fact-value">Extrinsic</span></span></div>' +
        '<div class="nsaq-fact-card"><span class="nsaq-fact-icon nsaq-fact-icon--graph" aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none"><path d="M4 20V15H7V20H4Z" fill="#74C69D"></path><path d="M9 20V11H12V20H9Z" fill="#52B788"></path><path d="M14 20V7H17V20H14Z" fill="#40916C"></path><path d="M19 20V3H22V20H19Z" fill="#2D6A4F"></path><path d="M3 21H22" stroke="#49AE79" stroke-width="1.5" stroke-linecap="round"></path></svg></span><span><span class="nsaq-fact-label">Room For Improvement</span><br><span class="nsaq-fact-value">High</span></span></div>' +
          '<div class="nsaq-fact-card"><span class="nsaq-fact-icon">' + ICONS.bolt + '</span><span><span class="nsaq-fact-label">Trigger</span><br><span class="nsaq-fact-value">Collagen Breakdown</span></span></div>' +
          '<div class="nsaq-fact-card"><span class="nsaq-fact-icon">' + ICONS.magnifier + '</span><span><span class="nsaq-fact-label">Impact on Appearance</span><br><span class="nsaq-fact-value">Noticeable</span></span></div>' +
        "</div>";
      return box;
    }
    function renderDateStep(step) {
  var wrap = document.createElement("div");
  wrap.className = "nsaq-date-form";

  var uid = "nsaq-" + sectionId + "-event-date-input";

  wrap.innerHTML =
    '<label class="nsaq-visually-hidden" for="' + uid + '">Event date</label>' +
    '<input type="date" id="' + uid + '" class="nsaq-date-input" data-nsaq-date-input>' +
    '<button type="button" class="nsaq-btn nsaq-btn--primary nsaq-date-continue" data-nsaq-date-continue disabled>' +
      'Continue <span aria-hidden="true">→</span>' +
    '</button>' +
    (step.skippable
      ? '<button type="button" class="nsaq-skip-step" data-nsaq-skip-date>Skip this step</button>'
      : '');

  var input = wrap.querySelector("[data-nsaq-date-input]");
  var dateContinue = wrap.querySelector("[data-nsaq-date-continue]");

  if (state.answers["event-date"]) {
    input.value = state.answers["event-date"];
    dateContinue.disabled = false;
  }

  input.addEventListener("change", function () {
    state.answers["event-date"] = input.value;
    dateContinue.disabled = !input.value;
    persist();

    pushDataLayerEvent("native_quiz_answer", baseEventPayload({
      step_id: step.id,
      step_number: state.currentIndex + 1,
      answer_id: input.value
    }));
  });

  dateContinue.addEventListener("click", function () {
    if (!input.value || isTransitioning) return;
    goNext();
  });

  var skipBtn = wrap.querySelector("[data-nsaq-skip-date]");

  if (skipBtn) {
    skipBtn.addEventListener("click", function () {
      if (isTransitioning) return;

      state.answers["event-date"] = null;
      persist();
      goNext();
    });
  }

  return wrap;
}
  
    function metricBars(kind) {
      var cls = "nsaq-metric-bar" + (kind === "now" ? " nsaq-metric-bar--now" : " nsaq-metric-bar--goal");
      return '<div class="' + cls + '"><span></span><span></span><span></span></div>';
    }

    function renderOffer(step) {
      var wrap = document.createElement("div");
      var sixMonthsDate = formatSixMonthsFromNow(); // verified dynamic calc, everything else fixed
      wrap.innerHTML =
        '<p class="nsaq-eyebrow">Based on your answers:</p>' +
        '<h2 class="nsaq-title">' + escapeHtml(cfg.resultHeadline || "You Are Just 6 Months Away From Firmer, More Rested-Looking Skin") + "</h2>" +
        '<p class="nsaq-subtitle">Here\'s what you can expect:</p>' +
        '<div class="nsaq-offer-checklist">' +
          '<p class="nsaq-offer-check"><span class="nsaq-check-icon" aria-hidden="true">✅</span>First visible results after just 1st application.</p>' +
          '<p class="nsaq-offer-check"><span class="nsaq-check-icon" aria-hidden="true">✅</span>Reduced appearance of wrinkles &amp; visibly tightened sagging skin by ' + escapeHtml(sixMonthsDate) + "</p>" +
        "</div>" +
        '<div class="nsaq-compare">' +
          '<div class="nsaq-compare-col">' +
            '<span class="nsaq-compare-tag nsaq-compare-tag--now">Now</span>' +
            (step.before ? '<img src="' + escapeHtml(step.before) + '" alt="Current appearance" loading="lazy" width="130" height="170">' : "") +
            '<div class="nsaq-compare-metric"><div class="nsaq-compare-metric-label">Skin Elasticity</div><div class="nsaq-compare-metric-value">Low</div>' + metricBars("now") + "</div>" +
            '<div class="nsaq-compare-metric"><div class="nsaq-compare-metric-label">Wrinkles &amp; Lines</div><div class="nsaq-compare-metric-value">Moderate to Deep</div>' + metricBars("now") + "</div>" +
            '<div class="nsaq-compare-metric"><div class="nsaq-compare-metric-label">Natural Collagen Levels</div><div class="nsaq-compare-metric-value">Below Average</div>' + metricBars("now") + "</div>" +
          "</div>" +
          '<div class="nsaq-compare-arrow" aria-hidden="true">' + ICONS.chevron + "</div>" +
          '<div class="nsaq-compare-col">' +
            '<span class="nsaq-compare-tag nsaq-compare-tag--goal">Your Goal</span>' +
            (step.after ? '<img src="' + escapeHtml(step.after) + '" alt="Goal appearance" loading="lazy" width="130" height="170">' : "") +
            '<div class="nsaq-compare-metric"><div class="nsaq-compare-metric-label">Skin Elasticity</div><div class="nsaq-compare-metric-value">Firmed up</div>' + metricBars("goal") + "</div>" +
            '<div class="nsaq-compare-metric"><div class="nsaq-compare-metric-label">Wrinkles &amp; Lines</div><div class="nsaq-compare-metric-value">Visibly Erased</div>' + metricBars("goal") + "</div>" +
            '<div class="nsaq-compare-metric"><div class="nsaq-compare-metric-label">Natural Collagen Levels</div><div class="nsaq-compare-metric-value">High</div>' + metricBars("goal") + "</div>" +
          "</div>" +
        "</div>" +
        '<button type="button" class="nsaq-btn nsaq-btn--gold" data-nsaq-cta style="margin-top:14px;">' +
          escapeHtml(cfg.ctaLabel || "CLAIM MY DISCOUNT") + ' <span aria-hidden="true">▷</span>' +
        "</button>";

      var ctaBtn = wrap.querySelector("[data-nsaq-cta]");
      ctaBtn.addEventListener("click", function () {
        if (isTransitioning) return;
        handleCtaClick(ctaBtn);
      });

      return wrap;
    }

    /* ---------------- Payload / submission ---------------- */

    function buildResponsePayload() {
      return {
        quiz_name: cfg.quizName,
        quiz_version: cfg.quizVersion,
        session_id: state.sessionId,
        variant_id: variantId,
        started_at: state.startedAt,
        completed_at: Date.now(),
        answers: state.answers,
        utm: getUtmParams(),
        page_url: window.location.href
      };
    }

    function sendResponsePayload() {
      var endpoint = cfg.endpointUrl;
      if (!endpoint) return Promise.resolve();
      try {
        return fetch(endpoint, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(buildResponsePayload()),
          keepalive: true
        }).catch(function () { /* never block the user on network/server failure */ });
      } catch (e) { return Promise.resolve(); }
    }

 function handleCtaClick(btn) {
  if (isTransitioning) return;

  isTransitioning = true;
  btn.classList.add("nsaq-btn--loading");
  btn.disabled = true;

  btn.innerHTML =
    '<span class="nsaq-btn-spinner" aria-hidden="true"></span>' +
    '<span>Loading...</span>' +
    '<span aria-hidden="true">▷</span>';

  pushDataLayerEvent(
    "native_quiz_cta_click",
    baseEventPayload({
      step_id: "quiz-results",
      step_number: state.currentIndex + 1,
      total_steps: STEPS.length,
      result_id: "high-fixed"
    })
  );

  sendResponsePayload().then(function () {
    scheduleTimer(function () {
      isTransitioning = false;
      goNext();
    }, 800);
  });
}

    /* ------------------------------------------------------------------
     * Navigation & history
     *
     * Rendering and history-writing are strictly one-directional:
     *   history change  -->  render
     * never the reverse. renderStepAtIndex() ONLY renders; it never
     * calls pushState/replaceState. The three entry points below are the
     * only places history is ever written, and none of them is called
     * from inside a popstate handler, so no recursive loop is possible.
     *   1. boot()        -> history.replaceState (first paint, no new entry)
     *   2. goNext()       -> history.pushState (every forward step)
     *   3. goBack()       -> history.back() (browser handles the state
     *                        change itself; our popstate listener then
     *                        renders — we never push/replace here)
     * ------------------------------------------------------------------ */

    function renderStepAtIndex(index, isBackDirection) {
      clearAllTimers();
      state.currentIndex = index;
      persist();

      stage.innerHTML = "";
      var step = currentStep();
      stage.appendChild(renderStepMarkup(step));
      updateProgress();

      backBtn.hidden = false;

      if (step.type === "single") setContinueEnabled(Boolean(state.answers[step.id]));
      else if (step.type === "multi") setContinueEnabled(isMultiAnswered(step));
      else if (step.type === "date") { /* handled in renderDateStep */ }
      else setContinueEnabled(true);

      if (step.type === "loading") {
  navEl.setAttribute("data-nsaq-hide-nav", "true");

  if (step.showCheckBeforeNext) {
    scheduleTimer(function () {
      var spinner = stage.querySelector(".nsaq-loading-spinner");

      if (spinner) {
        var checkWrap = document.createElement("div");
        checkWrap.className = "nsaq-loading-icon nsaq-loading-icon--complete";
        checkWrap.setAttribute("aria-hidden", "true");
        checkWrap.innerHTML = ICONS.check;

        spinner.replaceWith(checkWrap);
      }
    }, step.checkAfterMs || 1400);
  }

  scheduleTimer(function () {
    if (step.isFinal && cfg.ctaUrl) {
      window.location.href = cfg.ctaUrl;
    } else {
      goNext();
    }
  }, step.durationMs || 2200);

      } else if (step.type === "offer") {
        navEl.setAttribute("data-nsaq-hide-nav", "true");
      } else {
        navEl.removeAttribute("data-nsaq-hide-nav");
        navEl.setAttribute("data-nsaq-hide-continue", step.autoAdvance ? "true" : "false");
      }

      pushDataLayerEvent(
  "native_quiz_step_view",
  baseEventPayload({
    step_id: step.id,
    step_number: state.currentIndex + 1,
    total_steps: STEPS.length
  })
);

if (step.id === "quiz-results" && !state.completed) {
  pushDataLayerEvent(
    "native_quiz_complete",
    baseEventPayload({
      step_id: "quiz-results",
      step_number: state.currentIndex + 1,
      total_steps: STEPS.length,
      result_id: "high-fixed"
    })
  );

  state.completed = true;
  persist();
}

if (isBackDirection) {
        pushDataLayerEvent("native_quiz_back", baseEventPayload({
          step_id: step.id, step_number: state.currentIndex + 1
        }));
      }

      announce(step.title || "");
    }

    function pushHistoryEntry(stepId, index) {
      try { history.pushState({ nsaqStepIndex: index }, "", "#" + stepId); }
      catch (e) { /* ignore in restrictive environments */ }
    }

    function replaceHistoryEntry(stepId, index) {
      try { history.replaceState({ nsaqStepIndex: index }, "", "#" + stepId); }
      catch (e) { /* ignore in restrictive environments */ }
    }

    function goNext() {
      if (isTransitioning) return;
      var step = currentStep();
      var nextId = getNextStepId(step);
      if (!nextId) return;
      var nextIndex = findIndexById(nextId);
      if (nextIndex === -1) return;

      isTransitioning = true;
      pushHistoryEntry(nextId, nextIndex); // real forward history entry
      renderStepAtIndex(nextIndex, false);
      window.setTimeout(function () { isTransitioning = false; }, 200);
    }

    function goBack() {
  if (isTransitioning) return;

  if (state.currentIndex === 0) {
    history.back();
    return;
  }

  isTransitioning = true;
  history.back();

  window.setTimeout(function () {
    isTransitioning = false;
  }, 250);
}

    // The only place a browser Back/Forward navigation (including our own
    // Back button, which triggers history.back()) is turned into a render.
    // This handler NEVER calls pushState/replaceState.
    window.addEventListener("popstate", function (e) {
      var targetIndex = null;
      if (e.state && typeof e.state.nsaqStepIndex === "number") {
        targetIndex = e.state.nsaqStepIndex;
      } else {
        var hashId = window.location.hash.replace("#", "");
        var idx = findIndexById(hashId);
        if (idx !== -1) targetIndex = idx;
      }
      if (targetIndex === null) targetIndex = 0;
      if (targetIndex === state.currentIndex) return;

      var wasBack = targetIndex < state.currentIndex;
      renderStepAtIndex(targetIndex, wasBack);
    });

    continueBtn.addEventListener("click", function () {
      if (isTransitioning) return;
      var step = currentStep();
      if (step.type === "multi" && !isMultiAnswered(step)) return;
      if (step.type === "single" && !state.answers[step.id]) return;
      if (step.type === "date" && !state.answers[step.id]) return;
      goNext();
    });

    backBtn.addEventListener("click", goBack);

    root.addEventListener("keydown", function (e) {
      if (e.key !== "Enter") return;
      if (!document.activeElement || !root.contains(document.activeElement)) return;
      if (document.activeElement.matches("input,button,a")) return; // native behavior handles these
      if (!continueBtn.disabled && !continueBtn.hidden) continueBtn.click();
    });

    function boot() {
      var initialIndex = 0;
      var hashId = window.location.hash.replace("#", "");
      var idx = findIndexById(hashId);
      if (idx !== -1 && (!storage || !storage.getItem(storageKey))) {
        initialIndex = idx;
      } else {
        initialIndex = state.currentIndex || 0;
      }

      pushDataLayerEvent("native_quiz_view", baseEventPayload({}));
      if (!state.hasStarted) {
        state.hasStarted = true;
        persist();
        pushDataLayerEvent("native_quiz_start", baseEventPayload({ step_id: STEPS[initialIndex].id }));
      }

      // First paint only: replace the current history entry so it carries
      // our state object, without creating a new entry the user would
      // have to click Back through to leave the page.
      replaceHistoryEntry(STEPS[initialIndex].id, initialIndex);
      renderStepAtIndex(initialIndex, false);
    }

    boot();
  }

  function initAll() {
    var roots = document.querySelectorAll("[data-nsaq-root]");
    roots.forEach(function (root) { initQuiz(root); });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  // Shopify Theme Editor safe re-init: sections get re-injected on edit.
  // The data-nsaq-initialized guard on each root prevents double-binding.
  document.addEventListener("shopify:section:load", function (evt) {
    var root = evt.target.querySelector ? evt.target.querySelector("[data-nsaq-root]") : null;
    if (root) initQuiz(root);
  });
  document.addEventListener("shopify:section:reorder", initAll);
})();